import { useMemo } from 'react';
import { Text as MantineText, TextProps as MantineTextProps } from '@mantine/core';
import { textVariants, headings } from '@ui/tokens/typography/typography';

type TextVariant = keyof typeof textVariants;
type HeadingsVariant = keyof typeof headings;

interface TextProps extends MantineTextProps {
	variant?: TextVariant | HeadingsVariant
}

const stylesForVariant = ( variant: TextVariant | HeadingsVariant ) => (
	variant in headings
		? headings[ variant as HeadingsVariant ]
		: textVariants[ variant as TextVariant ]
)

const Text = ( { variant = 'body', style: styleProp, ...props }: TextProps = {} ) => {
	const style = useMemo( () => (
		{ ...stylesForVariant( variant ), ...( styleProp || {} ) }
	), [ styleProp, variant ] );

	return <MantineText style={style} {...props} />
};

export default Text;
